import React, { useEffect, useState } from 'react';
import axios from 'axios';
import { Link } from 'react-router-dom';
import { Check } from 'lucide-react';
import { API } from '../../../lib/api';
import { fmtINR } from '../billing/shared';

// Pick one or more priced packages; selected ones are stored on the booking as a snapshot.
export const PackagePicker = ({ authHeader, value, onChange }) => {
  const [all, setAll] = useState(null);
  useEffect(() => {
    axios.get(`${API}/appointments/packages`, { headers: authHeader() }).then(({ data }) => setAll(data)).catch(() => setAll([]));
  }, [authHeader]);
  const picked = new Set(value.map((p) => p.id));
  const toggle = (p) => onChange(picked.has(p.id) ? value.filter((x) => x.id !== p.id) : [...value, { id: p.id, name: p.name, price: p.price, gst_rate: p.gst_rate }]);
  const options = [...(all || []).filter((p) => p.active), ...value.filter((v) => !(all || []).some((p) => p.id === v.id && p.active))];
  const total = value.reduce((s, p) => s + Number(p.price || 0), 0);
  return (
    <div className="rounded-xl border border-slate-200 bg-white p-4" data-testid="apt-packages">
      <div className="mb-3 flex items-baseline justify-between gap-2">
        <h2 className="text-sm font-semibold text-slate-800">Packages</h2>
        <Link to="/admin/settings?tab=packages" className="text-[11px] font-semibold text-teal-700 hover:underline" data-testid="apt-packages-manage">Edit prices</Link>
      </div>
      {all !== null && options.length === 0 && <p className="text-xs text-slate-500" data-testid="apt-packages-empty">No packages yet. Add them under Settings › Service packages.</p>}
      <div className="grid grid-cols-1 gap-2 sm:grid-cols-2">
        {options.map((p) => {
          const on = picked.has(p.id);
          return (
            <button key={p.id} type="button" onClick={() => toggle(p)} data-testid={`apt-package-${p.id}`}
              className={`flex items-center justify-between gap-2 rounded-lg border px-3 py-2 text-left text-xs transition-colors ${on ? 'border-teal-600 bg-teal-50' : 'border-slate-300 bg-white hover:border-teal-400'}`}>
              <span className="flex items-center gap-2 font-semibold text-slate-800">
                <span className={`flex h-4 w-4 items-center justify-center rounded border ${on ? 'border-teal-600 bg-teal-600 text-white' : 'border-slate-300'}`}>{on && <Check size={11} />}</span>
                {p.name}
              </span>
              <span className="font-mono text-slate-600">₹ {fmtINR(p.price)}</span>
            </button>
          );
        })}
      </div>
      {value.length > 0 && (
        <p className="mt-3 flex justify-between border-t border-slate-100 pt-2 text-sm font-semibold text-slate-900" data-testid="apt-packages-total">
          <span>Estimated total ({value.length})</span><span className="font-mono">₹ {fmtINR(total)}</span>
        </p>
      )}
    </div>
  );
};
